import { request } from '@/shared/api/request'

export const getContractData = (params) => {
	return request({ url: '/staff/universalMethods/actualContractData', method: 'GET', params })
}
